import AddressOption from '@components/order/models/edit/AddressOption';
import RestaurantMenuTwoToneIcon from '@mui/icons-material/RestaurantMenuTwoTone';
import { observer } from 'mobx-react-lite';
import React from 'react';
import AddressOptionListItem from './AddressOptionListItem';

interface ServeInRestaurantOptionListItemProps {
    selectedValue: AddressOption;
    setAddressOption: (addressOption: AddressOption) => void;
}

const ServeInRestaurantOptionListItem: React.FC<ServeInRestaurantOptionListItemProps> = observer(({ selectedValue, setAddressOption }) => {
    var isSelected = "isServedInRestaurant" === selectedValue;
    return (
        <AddressOptionListItem
            title={"Jedem u restoranu"}
            icon={<RestaurantMenuTwoToneIcon color={isSelected ? "secondary" : "action"} />}
            value={"isServedInRestaurant"}
            selectedValue={selectedValue}
            onClick={setAddressOption} />
    )
})

export default ServeInRestaurantOptionListItem;